module.exports = __webpack_public_path__ + "static/media/php.db60adc4.jpg";